import React from 'react';
import { Upload, Icon, message } from 'antd';

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('你只能提交JPG或者PNG格式!');
  }
  const isLt2M = file.size / 1024 / 1024 < 10;
  if (!isLt2M) {
    message.error('图片不能大于2MB!');
  }
  return isJpgOrPng && isLt2M;
}

class UpPhoto extends React.Component{

  state = {
    loading: false,
    //domain:'http://10.0.7.102:3005/switch/upload/image',
    domain:"/switch/upload/image",
    imageUrl:localStorage.getItem("photo")
  };

//组件将要挂载时候加载的生命周期函数
 componentWillMount(){
   let imageUrl=this.state.imageUrl;
   //如果村宝用户id 不用空初始化 state 信息
   //aixo 请求 TODO
    //imageUrl=""
  if(!imageUrl===""){
   this.props.pfn(imageUrl);
}
  }
handleChange = info => {
  if (info.file.status === 'uploading') {
    this.setState({ loading: true });
    return;
  }
  if (info.file.status === 'done') {
    this.props.pfn(info.file.response.data);
    // Get this url from response in real world.
    getBase64(info.file.originFileObj, imageUrl =>
      this.setState({
        imageUrl,
        loading: false,
      }),
    );
  }
};  
      render() {
        const uploadButton = (
          <div>
            <Icon type={this.state.loading ? 'loading' : 'plus'} />
            <div className="ant-upload-text" style={{color:'#bfbfbf',fontSize:'10px'}}>(332*167像素)</div>
          </div>
        );
        const { imageUrl } = this.state;
        return (
          <Upload
            name="image"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={this.state.domain}
            beforeUpload={beforeUpload}
            onChange={this.handleChange}
          >
            {imageUrl ? <img src={imageUrl} alt="image" style={{ width: '100%' }} /> : uploadButton}
          </Upload>
          
        );
      }   
}

export default UpPhoto;


// WEBPACK FOOTER //
// ./src/components/Model/UpPhoto.js